/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import router from '../router'
import axios from 'axios'
axios.defaults.withCredentials = true;

const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    // Ecom - Attempt to load user currently logged in backend
    async attemptLoadUser({commit}){
      try {
        let user = await axios.get( process.env.VUE_APP_BACKEND_URL + 'api/user');
        //let orders = await axios.get( process.env.VUE_APP_BACKEND_URL + 'api/orders');// api/user no da CORS
        //console.log('orders.data')
        //console.log(orders.data)
        if(user.data){
          /*await */commit('AUTH_USER', user.data);
        }
      } catch(e){
        // GET /api/user 401 (Unauthorized)
        //return false;
        router.push('/guest')
      }
      
    },

    async logout({commit}){
      console.log('action - logout');
      try{
        await axios.get( process.env.VUE_APP_BACKEND_URL + 'logout');
      } catch(e){
        console.log('sesion cerrada - ya no está autenticado');
      }
      commit('AUTH_USER', {});
      router.push('/guest');
    },

    async getorders(){
      console.log('getorders action')
      try{
        let orders = await axios.get( process.env.VUE_APP_BACKEND_URL + 'api/orders')// api/user no da CORS
        console.log(orders.data)
      } catch(e){
        console.log(e)
      }
    }

}

export default actions
